import React from 'react';
import { ParentStatistics, StatisticItemKey, StatisticSectionKey } from '~/components/Statistics';
import { PatientService } from '~/services';

interface StatisticsProps {
    setStatus: (section: string, item: string | number) => void;
    page: string;
    status: number;
    patientId: number;
    scrollToItem?: (item: string) => void;
    healthHxVal?: string | number;
}
function Statistics({
    setStatus,
    page,
    status,
    patientId,
    healthHxVal = '0',
    scrollToItem = () => {},
}: StatisticsProps) {
    function getLink(
        e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
        section: StatisticSectionKey,
        item: StatisticItemKey
    ) {
        e.preventDefault();
        setStatus(section, item);
    }

    function getActiveBadge(section: StatisticSectionKey, item: StatisticItemKey) {
        return page === section && status === parseInt(item as string) ? 'badge-outline-' : 'bg-';
    }

    return (
        <ParentStatistics
            evt={PatientService.EVENTS.patient_updated}
            patientView
            getLink={getLink}
            getActiveBadge={getActiveBadge}
            patientId={patientId}
            healthHxVal={healthHxVal}
            scrollToItem={scrollToItem}
        />
    );
}

export { Statistics };
